import React, { useState, useEffect, useContext } from 'react'
import deleteIcon from '../../images/png/deleteIcon.png'
import editIcon from '../../images/png/editIcon.png'

import styled from 'styled-components'
import Skeleton from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import api from '../../services/api'

import { PagesContext } from '../../context/pages'

const Image = styled.img`
    width: 28px;
    height:26px;
    object-fit: contain;

    @media screen and (max-width:720px){

        width: 21px;
        height: 21px;
        margin-left: 0.8rem;
        
    }

`

const Li = styled.li`
    position: relative;
    width: auto;
    display: flex; 
    justify-content:center;
    align-items: last baseline;
    border:none;
    list-style:none;
    background-color: white;
    border: none;


`
const PreviewImage = styled.img`
    position: absolute;
    object-fit: contain;

    left:0;
    width: 22px;
    height: 22px;

`

const TableListButtons = ({ data, structure }) => {
    const {getAllButtons,buttons,deleteButton,animation,setShowModalEditButton,setButtonId,setButtonName,setButtonImage} = useContext(PagesContext)

    useEffect(() => {
        getAllButtons()
    },[])
    

    return (
        <div className='container_startpn_table_categorys'>
            <table>

                <thead className='container_startpn_table_categorys'>
                    <tr>
                        {structure?.map((item, index) => {
                            return (
                                <td key={index}>{item.name}</td>

                            )
                        })}
                    </tr>
                </thead>

                <tbody className=''>
                    {animation

                        ?
                        <tr>
                            <td data-toggle="modal" data-target=""><Skeleton width={"100%"} /></td>
                            <td data-toggle="modal" data-target=""><Skeleton width={"100%"} /></td>
                            <td data-toggle="modal" data-target=""><Skeleton width={"100%"} /></td>
                            <td data-toggle="modal" data-target=""><Skeleton width={"100%"} /></td>
                            <td data-toggle="modal" data-target=""><Skeleton width={"100%"} /></td>

                        </tr>
                        :

                        buttons?.map((item, index) => {
                            return (
                                <tr key={index}>
                                    <td>#{item.id}</td>
                                    <td data-toggle="modal" data-target="" onClick={() => {setShowModalEditButton(true);setButtonId(item.id);setButtonName(item.name);setButtonImage(item.image)}}>{item.name}</td>
                                    <td data-toggle="modal" data-target="" onClick={() => {setShowModalEditButton(true);setButtonId(item.id);setButtonName(item.name);setButtonImage(item.image)}}><Li><PreviewImage src={item.image} />{item.name}</Li></td>
                                    <td data-toggle="modal" data-target="" onClick={() => {setShowModalEditButton(true);setButtonId(item.id);setButtonName(item.name);setButtonImage(item.image)}}><Image src={editIcon}/></td>
                                    <td data-toggle="modal" data-target="" onClick={() => deleteButton(item.id)} > <Image src={deleteIcon}/></td>

                                </tr>
                            )
                        })}



                </tbody>
            </table>
        </div>
    )
}

export default TableListButtons